import { AxiosObservable } from '@cbridge-utils/axios-observable';
import { ApiServiceType, BaseService, FILE_UPLOAD_HEADERS, BlobWithHeaders, transformBlobResponse } from '@cbridge-packages/api-base';
import { IApiGetPricesReq, IApiGetPricesRes } from '../_interfaces/prices/IApiGetPrices';

export class ConversionApiService extends BaseService {
  constructor() {
    super(ApiServiceType.ConversionService);
  }

  getPrices(payload: IApiGetPricesReq): AxiosObservable<IApiGetPricesRes> {
    return this.api.get<IApiGetPricesRes>('/prices/symbols', { params: payload });
  }

  exportPrices(): AxiosObservable<BlobWithHeaders> {
    return this.api.get<BlobWithHeaders>('/prices/export', {
      responseType: 'blob',
      transformResponse: transformBlobResponse,
    });
  }

  importPrices(payload: { file: File }): AxiosObservable<void> {
    return this.api.post<void>('/prices/import', payload, FILE_UPLOAD_HEADERS);
  }
}
